import { combineReducers } from 'redux';
import printFoil from './printFoil.reducer';

const printReducers = combineReducers({
  printFoil,
});

export default printReducers;
